import type { FormField } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptField } from '../schema-prompts/prompt-field.js'
import { createFieldPromptOptions } from './create-field-prompt-options.js'

export async function promptFormField(schemasDir: string, fields: FormField[]): Promise<void> {
  fields.push(
    (await promptField(
      CREATE_PROMPT_CONTEXT,
      'form',
      schemasDir,
      'schema',
      0,
      createFieldPromptOptions(fields)
    )) as FormField
  )
}
